module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-192x192-81df49b5c80ece8ad144fd348409069c.png";